module.exports = new __parcel__URL__("ice_storm_tracker_cosmetic.57957759.png").toString();